/**
 * 数据上报
 */

import '@common/polyfill/src/Object.assign'
import domain from '@common/domain'
import ajax from './lib/ajax'
import setBaidu from './lib/baidu'
import setGa from './lib/ga'
import { setUrlData, getUrlData } from './data/data_url'
import { setSystemData, getSystemData } from './data/data_system'
import { getClientData } from './data/data_client'
import dataTpl from './data/data_tpl'

let collectReady = false
let urlData
let systemData
let clientData
let collectData
let isInit = false // 是否有运行初始化设置
let _callbacks = {}

// 检测是否准备完毕
const ready = () => {
  return new Promise(async (resolve, reject) => {
    if (!isInit) {
      const msg = 'Collect Error: 未初始化设置，请运行 collect.init().'
      console.error(msg)
      reject(msg)
    }
    if (collectReady) {
      resolve({
        urlData,
        systemData,
        clientData
      })
    }
    try {
      setUrlData()
      setSystemData()
      clientData = await getClientData()
      urlData = getUrlData()
      systemData = await getSystemData()
      collectReady = true
      resolve({
        urlData,
        systemData,
        clientData
      })
    } catch (error) {
      reject('Ready Error:', error)
    }
  })
}

// 请求
const request = (args) => {
  ready().then((data) => {
    const sendData = dataTpl({ ...data, ...args })
    console.log('Collect SendData:', sendData)
    ajax({
      type: 'POST',
      url: `${domain.collect}/log-collect/front-behaviour`,
      data: {
        content: JSON.stringify(sendData),
        em: 'n',
      },
      success: (result) => {
        console.log('Collect Success: ' + JSON.stringify(result))
        publish('afterCollectResult')
      },
      error: (error) => {
        console.log('Collect Error: ' + JSON.stringify(error))
        publish('afterCollectResult')
      },
    })
    publish('afterCollect', sendData)
  }).catch((error) => {
    console.log(error)
    publish('afterCollectResult')
  })
}

/**
 * 发布事件
 * @param {*} ev 事件名
 * @param  {...any} args 事件参数
 */
const publish = (ev, ...args) => {
  try {
    const list = _callbacks[ev] || []
    if (list.length) {
      let i = 0
      let length = list.length
      for (; i < length; i++){
        list[i].apply(this, args)
      }
    }
  } catch (e) {
    console.error(e)
  }
}

/**
 * 订阅事件
 * @param {*} ev 事件名
 * @param {*} callback 事件
 * @param {*} uniqueEvent 是否唯一事件，默认:false--多次订阅事件都会被触发;true--只会触发最后一次订阅事件
 */
export const subscribe = (ev, callback, uniqueEvent = false) => {
  if (!_callbacks[ev]) {
    _callbacks[ev] = []
  }
  if (uniqueEvent) {
    _callbacks[ev] = []
  }
  _callbacks[ev].push(callback)
}

// 数据初始化
// 需要兼容之前旧的调用方式,旧版调用方式为init(flowName, pageName)
export const init = (...args) => {
  if (typeof args[0] === 'object') {
    const { baidu, ga, flowName, pageName } = Object.assign({
      baidu: true,
      ga: true,
      flowName: 'finance',
      pageName: ''
    }, args[0])
    collectData = { flowName, pageName }
    if (!isInit) {
      baidu && setBaidu()
      ga && setGa()
    }
  } else {
    collectData = {
      flowName: args[0],
      pageName: args[1]
    }
  }
  isInit = true
}

// 上报view
export const trackView = (title = '', params = {}, customJson = {}) => {
  request({
    configData: {
      title,
      etype: 'view'
    },
    collectData,
    params,
    customJson
  })
}

// 上报event
export const trackEvent = (title = '', params = {}, customJson = {}) => {
  request({
    configData: {
      title,
      etype: 'click'
    },
    collectData,
    params,
    customJson
  })
}

// 兼容之前的版本，新用法建议更新
export const sendRequest = (title, etype, params = {}, customJson = {}) => {
  if (etype === 'click') {
    trackEvent(title, params, customJson)
  } else {
    trackView(title, params, customJson)
  }
}

export default {
  init,
  trackView,
  trackEvent,
  sendRequest,
  subscribe
}


// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/node_modules/@common/collect/src/index.js